var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("US $"+_vm._s(_vm.amountPaid/100)+".0")])}
var staticRenderFns = []

export { render, staticRenderFns }